import { APP_INITIALIZER, InjectionToken, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { LoginCallbackComponent } from './auth/login-callback/login-callback.component';
import { ApiService } from './services/api.service';
import { BazaService } from './services/baza.service';
import { EmriBazaService } from './services/emri-baza.service';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { AuthConfig, OAuthModule, OAuthModuleConfig } from 'angular-oauth2-oidc';
import { authAppInitializerFactory } from './auth/auth-app-initializer.factory';
import { AuthService } from './auth/auth.service';
import { authConfig } from './auth/auth-config';
import { authModuleConfig } from './auth/auth-module-config';
import { UnauthorizedComponent } from './auth/unauthorized/unauthorized.component';
import { ForbiddenComponent } from './auth/forbidden/forbidden.component';
import { ShenimetPopupComponent } from './header/shenimet-popup/shenimet-popup.component';
import { PerdoruesitComponent } from './header/perdoruesit/perdoruesit.component';
import { PerdoruesiInfoComponent } from './header/perdoruesit/perdoruesi-info/perdoruesi-info.component';

@NgModule({
  declarations: [LoginCallbackComponent, HeaderComponent, UnauthorizedComponent, ForbiddenComponent, ShenimetPopupComponent, PerdoruesitComponent, PerdoruesiInfoComponent],
  imports: [SharedModule, RouterModule, OAuthModule.forRoot()],
  exports: [HeaderComponent, UnauthorizedComponent],
  providers: [ApiService, BazaService, EmriBazaService],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: authAppInitializerFactory,
          deps: [AuthService],
          multi: true,
        },
        { provide: AuthConfig, useValue: authConfig },
        { provide: OAuthModuleConfig, useValue: authModuleConfig },
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
